import { useSelector } from "react-redux"
import { selectMeetings } from "./meetingsSlice"

export const useMeetings = () => {
  const { body, updating } = useSelector(selectMeetings)

  return {
    body,
    updating,
  }
}